import { render, staticRenderFns } from "./VisualTableList.vue?vue&type=template&id=b81abec6&scoped=true&"
import script from "./VisualTableList.vue?vue&type=script&lang=js&"
export * from "./VisualTableList.vue?vue&type=script&lang=js&"
import style0 from "./VisualTableList.vue?vue&type=style&index=0&id=b81abec6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81abec6",
  null
  
)

export default component.exports